angular.module('core')
    .service('dblAssignmentService', ['moment', function(moment) {

    /**
     * Return an object representing the timeframe starting from the current time
     * an ending some number of weeks in the future.
     *
     * The return object contans a start and end field containing momentjs
     * objects created in utc mode.
     **/
    this.generateAssignmentDates = function (numberOfWeeks) {
        // using momentjs utc mode allows the addition of weeks
        // to have the same time of day as the start, even when it crosses
        // daylight saving boundaries
        var dates = {
            start: moment().utc(),
            end: moment().add(numberOfWeeks, 'week').utc()
        };

        return dates;
    };

}]);
